module.exports = __webpack_public_path__ + "img/back-3-n-00e4fc79.png";